import React from 'react';
import style from "../css/OuterDiv.module.css";

const OuterDiv = (props) => {
    return (
        <div className={style.outerDiv}>
            {props.children}
        </div>
    )
}

export default OuterDiv
